
function addDropzone(self) {
  import("dropzone").then( ({default: Dropzone}) => {
    window.Dropzone = Dropzone;
    Dropzone.autoDiscover = false;
    let dropzone = self.el.querySelector(".dropzone-wrapper");

    let container = document.createElement('div')
    container.id = `${dropzone.id}-container`
    container.setAttribute("phx-update", "ignore");
    container.classList.add('dropzone')
    dropzone.appendChild(container)

    let myDropzone = new Dropzone(`#${container.id}`, {
      dictDefaultMessage: dropzone.dataset.defaultMessage,
      url: dropzone.dataset.url,
      paramName: dropzone.dataset.paramName,
      acceptedFiles: "image/*",
      maxFilesize: 40,
      clickabke: true,
      method: "put",
      headers: {
        'x-csrf-token': dropzone.dataset.csrfToken
      }
    });
    let componentToRefresh = dropzone.dataset.componentToRefresh
    myDropzone.on("success", () => {
      self.pushEventTo(componentToRefresh, "upload-success", "", () => {})
    })
  })
}

const Hooks = {
  mounted() { addDropzone(this) },
  updated() { addDropzone(this) }
}

export default Hooks;
